import type { RouteRecordRaw } from 'vue-router';
import iconIndustry from '/@/assets/images/menu-industry.png';

export const userRoutes: Array<RouteRecordRaw> = [
  {
    path: '/personal',
    name: 'Personal',
    component: () => import('/@/views/account/index.vue'),
    meta: {
      requriedLogined: true,
      title: '个人中心',
      icon: 'iconfont icon-icon_shouye',
      tagsViewName: '个人中心',
    },
    children: [],
  },
  {
    path: '/industry',
    name: 'Industry',
    redirect: '/industry/mineregister',
    meta: {
      requriedLogined: true,
      title: '产教中心',
      // iconfont 中没有学士帽字形,使用图片图标
      iconImg: iconIndustry,
      tagsViewName: '产教中心',
    },
    children: [
      {
        path: '/industry/mineregister',
        name: 'MineRegister',
        component: () => import('/@/views/industry/registration.vue'),
        meta: {
          requriedLogined: true,
          title: '我的报名',
          tagsViewName: '我的报名',
        },
      },
      {
        path: '/industry/minecourse',
        name: 'MineCourse',
        component: () => import('/@/views/industry/course.vue'),
        meta: {
          requriedLogined: true,
          title: '我的入课',
          tagsViewName: '我的入课',
        },
      },
      {
        path: '/industry/mineproject',
        name: 'MineProject',
        component: () => import('/@/views/industry/project.vue'),
        meta: {
          requriedLogined: true,
          title: '我的项目',
          tagsViewName: '我的项目',
        },
      },
    ],
  },
  {
    path: '/auth',
    name: 'Auth',
    // redirect: "/auth/mineauth",
    component: () => import('/@/views/routerView/parent.vue'),
    meta: {
      requriedLogined: true,
      title: '认证中心',
      icon: 'iconfont icon-renzhengzhongxin',
      tagsViewName: '认证中心',
    },
    children: [
      {
        path: '/auth/mineauth',
        name: 'MineAuth',
        component: () => import('/@/views/routerView/parent.vue'),
        meta: {
          requriedLogined: true,
          title: '我的认证',
          tagsViewName: '我的认证',
        },
        redirect: '/auth/mineauth/list',
        children: [
          {
            path: 'list',
            name: 'MineAuthList',
            // component: () => import("/@/views/auth/index.vue"),
            component: () => import('/@/views/auth/myCert.vue'),
            meta: {
              requriedLogined: true,
              title: '我的认证',
              tagsViewName: '我的认证',
              isHide: true,
            },
          },
          {
            path: 'detail',
            name: 'MineAuthdetail',
            component: () => import('/@/views/auth/authDetail.vue'),
            meta: {
              requriedLogined: true,
              title: '认证详情',
              tagsViewName: '认证详情',
              isHide: true,
            },
            children: [],
          },
        ],
      },
      {
        path: '/auth/teamauth',
        name: 'TeamAuth',
        component: () => import('/@/views/routerView/parent.vue'),
        meta: {
          requriedLogined: true,
          title: '团体报名',
          tagsViewName: '团体报名',
        },
        redirect: '/auth/teamauth/team',
        children: [
          {
            path: 'team',
            name: 'TeamAuthTeam',
            component: () => import('/@/views/auth/team.vue'),
            meta: {
              requriedLogined: true,
              title: '团体报名',
              tagsViewName: '团体报名',
              isHide: true,
            },
          },
          {
            path: 'detail',
            name: 'TeamAuthDetail',
            component: () => import('/@/views/auth/teamDetail.vue'),
            meta: {
              requriedLogined: true,
              title: '查看详情',
              tagsViewName: '查看详情',
              isHide: true,
            },
            children: [],
          },
        ],
      },
      {
        path: '/auth/authsign',
        name: 'AuthSign',
        component: () => import('/@/views/auth/authsign.vue'),
        meta: {
          requriedLogined: true,
          title: '认证报名',
          tagsViewName: '认证报名',
          isHide: true,
        },
        children: [],
      },
      {
        path: '/auth/minecredentials',
        name: 'MineCredentials',
        // component: () => import('/@/views/auth/credentials.vue'),
        component: () => import('/@/views/auth/mycredentials.vue'),
        meta: {
          requriedLogined: true,
          title: '我的证书',
          tagsViewName: '我的证书',
        },
        children: [],
      },
    ],
  },
  {
    path: '/study',
    name: 'Study',
    redirect: '/study/minestudy',
    meta: {
      requriedLogined: true,
      title: '学习中心',
      icon: 'iconfont icon-xuexizhongxin',
      tagsViewName: '学习中心',
    },
    children: [
      {
        path: '/study/minestudy',
        name: 'MineStudy',
        component: () => import('/@/views/routerView/parent.vue'),
        meta: {
          requriedLogined: true,
          title: '我的课程',
          tagsViewName: '我的课程',
        },
        redirect: '/study/minestudy/course',
        children: [
          {
            path: 'course',
            name: 'MineStudyCourse',
            meta: {
              requriedLogined: true,
              title: '我的课程',
              tagsViewName: '我的课程',
              isHide: true,
            },
            component: () => import('/@/views/study/course.vue'),
            children: [],
          },
          {
            path: 'series',
            name: 'MineStudySeries',
            meta: {
              requriedLogined: true,
              title: '我的课程',
              tagsViewName: '我的课程',
              isHide: true,
            },
            component: () => import('/@/views/study/series.vue'),
            children: [],
          },
        ],
      },
      {
        path: '/study/minetrain',
        name: 'MineTrain',
        component: () => import('/@/views/routerView/parent.vue'),
        redirect: '/study/minetrain/joined',
        meta: {
          requriedLogined: true,
          title: '我的培训',
          tagsViewName: '我的培训',
        },
        children: [
          {
            path: 'joined',
            name: 'MineJoinedTrain',
            component: () => import('/@/views/study/train.vue'),
            meta: {
              requriedLogined: true,
              title: '我的培训',
              tagsViewName: '我的培训',
              isHide: true,
            },
          },
          {
            path: 'published',
            name: 'MinePublishedTrain',
            component: () => import('/@/views/study/trainpublished.vue'),
            meta: {
              requriedLogined: true,
              title: '我发布培训',
              tagsViewName: '我发布培训',
              isHide: true,
            },
          },
        ],
      },
      {
        path: '/study/exam',
        name: 'Exam',
        component: () => import('/@/views/routerView/parent.vue'),
        meta: {
          requriedLogined: true,
          title: '我的考试',
          tagsViewName: '我的考试',
        },
        redirect: '/study/exam/mineexam',
        children: [
          {
            path: 'mineexam',
            name: 'MineExam',
            component: () => import('/@/views/study/exam.vue'),
            meta: {
              requriedLogined: true,
              title: '我的考试',
              tagsViewName: '我的考试',
              isHide: true,
            },
          },
          {
            path: 'authexam',
            name: 'AuthExam',
            component: () => import('/@/views/study/authexam.vue'),
            meta: {
              requriedLogined: true,
              title: '认证考试',
              tagsViewName: '认证考试',
              isHide: true,
            },
          },
        ],
      },
      {
        path: '/study/minepro',
        name: 'MinePro',
        component: () => import('/@/views/study/product.vue'),
        meta: {
          requriedLogined: true,
          title: '我的产品',
          tagsViewName: '我的产品',
        },
      },
    ],
  },
  {
    path: '/competition',
    name: 'Competition',
    redirect: '/competition/minecompetition',
    meta: {
      requriedLogined: true,
      title: '大赛中心',
      icon: 'iconfont icon-dasaizhongxin',
      tagsViewName: '大赛中心',
    },
    children: [
      {
        path: '/competition/minecompetition',
        name: 'MineCompetition',
        component: () => import('/@/views/contest/minecontest.vue'),
        meta: {
          requriedLogined: true,
          title: '我的大赛',
          tagsViewName: '我的大赛',
        },
      },
      {
        path: '/competition/teamcompetition',
        name: 'TeamCompetition',
        component: () => import('/@/views/routerView/parent.vue'),
        meta: {
          requriedLogined: true,
          title: '院校报名',
          tagsViewName: '院校报名',
        },
        redirect: '/competition/teamcompetition/list',
        children: [
          {
            path: '/competition/teamcompetition/list',
            name: 'TeamCompetitionList',
            component: () => import('/@/views/contest/teamcontest.vue'),
            meta: {
              requriedLogined: true,
              title: '',
              tagsViewName: '',
              isHide: true,
            },
          },
          {
            path: '/competition/teamcompetition/detail',
            name: 'TeamCompetitionDetail',
            component: () => import('/@/views/contest/teamcontest-detail.vue'),
            meta: {
              requriedLogined: true,
              title: '',
              tagsViewName: '',
              isHide: true,
            },
          },
        ],
      },
    ],
  },
  {
    path: '/information',
    name: 'Information',
    redirect: '/information/mineorder',
    meta: {
      requriedLogined: true,
      title: '我的信息',
      icon: 'iconfont icon-icon_wodexinxi',
      tagsViewName: '我的信息',
    },
    children: [
      {
        path: '/information/mineorder',
        name: 'MineOrder',
        meta: {
          requriedLogined: true,
          title: '我的订单',
          tagsViewName: '我的订单',
        },
        component: () => import('/@/views/routerView/parent.vue'),
        redirect: '/information/mineorder/list',
        children: [
          {
            path: 'list',
            name: 'MineOrderList',
            component: () => import('/@/views/information/order.vue'),
            meta: {
              requriedLogined: true,
              title: '订单列表',
              tagsViewName: '订单列表',
              isHide: true,
            },
          },
          {
            path: 'detail/:orderId',
            name: 'MineOrderDetail',
            component: () => import('/@/views/information/orderdetail.vue'),
            meta: {
              requriedLogined: true,
              title: '订单详情',
              tagsViewName: '订单详情',
              isHide: true,
            },
          },
        ],
      },
      {
        path: '/information/minenotice',
        name: 'MineNotice',
        component: () => import('/@/views/information/message.vue'),
        meta: {
          requriedLogined: true,
          title: '通知消息',
          tagsViewName: '通知消息',
        },
      },
      {
        path: '/information/setting',
        name: 'AccountSetting',
        component: () => import('/@/views/information/setting.vue'),
        meta: {
          requriedLogined: true,
          title: '账户设置',
          tagsViewName: '账户设置',
        },
      },
    ],
  },
  {
    path: '/appraise',
    name: 'Appraise',
    redirect: '/appraise/mineappraise',
    meta: {
      requriedLogined: true,
      title: '我的评审',
      icon: 'iconfont icon-wodepingshen',
      tagsViewName: '我的评审',
    },
    children: [
      {
        path: '/appraise/mineappraise',
        name: 'MineAppraise',
        component: () => import('/@/views/appraise/mine.vue'),
        meta: {
          requriedLogined: true,
          title: '我的评审',
          tagsViewName: '我的评审',
          isLink: '/teststatistics/index.html',
        },
      },
    ],
  },
  {
    path: '/siteapply',
    name: 'SiteApply',
    redirect: '/siteapply/minesiteapply',
    meta: {
      requriedLogined: true,
      title: '我的申报',
      icon: 'iconfont icon-shenbaoxinxi',
      tagsViewName: '我的申报',
    },
    children: [
      {
        path: '/siteapply/minesiteapply',
        name: 'MineSiteApply',
        component: () => import('/@/views/application/mine.vue'),
        meta: {
          requriedLogined: true,
          title: '我的申报',
          tagsViewName: '我的申报',
        },
      },
    ],
  },
  {
    path: '/system',
    name: 'System',
    redirect: { name: 'InnerTrain' },
    meta: {
      requriedLogined: true,
      title: '内部通道',
      icon: 'iconfont icon-neibutongdao',
      tagsViewName: '内部通道',
    },
    children: [
      {
        path: '/system/innertrain',
        name: 'InnerTrain',
        component: () => import('/@/views/information/setting.vue'),
        meta: {
          requriedLogined: true,
          title: '内部培训系统',
          tagsViewName: '内部培训系统',
          isLink: '/train/index2.html',
        },
      },
    ],
  },
];

export const staticRoutes: Array<RouteRecordRaw> = [
  {
    path: '/',
    component: () => import('/@/views/user/index.vue'),
    redirect: '/personal',
    meta: {
      requriedLogined: true,
      title: '用户中心',
    },
    children: [...userRoutes],
  },
  // {
  // 	path: "/usercenter",
  // 	name: "UserCenter",
  // 	component: () => import("/@/views/user/index.vue"),
  // 	redirect: "/usercenter/personal",
  // 	meta: {
  // 		requriedLogined: true,
  // 		title: "用户中心"
  // 	},
  // 	children: [...userRoutes]
  // }
];

/**
 * 定义404、401界面
 * @link 参考：https://next.router.vuejs.org/zh/guide/essentials/history-mode.html#netlify
 */
export const notFoundAndNoPower = [
  {
    path: '/:path(.*)*',
    name: 'notFound',
    component: () => import('/@/views/error/404.vue'),
    meta: {
      isHide: true,
    },
  },
  {
    path: '/401',
    name: 'noPower',
    component: () => import('/@/views/error/401.vue'),
    meta: {
      isHide: true,
    },
  },
];
